module.exports = __webpack_public_path__ + "media/promo/velle/images/recipes/recipe_2-5aca84b68d7347f7061d734094d0c5c0.jpg";